<script setup>

import axios from "axios";

import {ref, onBeforeUnmount, onBeforeMount} from "vue";

import {useStore} from "vuex";
import {useRouter} from "vue-router";

import {toast} from "vue3-toastify";


// import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";

import loginImage from "@/assets/img/login.jpg";

import {useAuthStore} from "@/store/auth";

const authStore = useAuthStore();

console.log('authStore',authStore.getUser );

const body = document.getElementsByTagName("body")[0];

const store = useStore();
const router = useRouter();

const apiUrl = process.env.VUE_APP_API_URL;

console.info('apiUrl', apiUrl);

onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;

  store.state.isRTL = true;
  document.querySelector("html").setAttribute("lang", "fa");
  document.querySelector("html").setAttribute("dir", "rtl");
  // document.querySelector("#app").classList.add("rtl");
  body.classList.remove("bg-gray-100");


});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;

  store.state.isRTL = false;
  document.querySelector("html").removeAttribute("lang");
  document.querySelector("html").removeAttribute("dir");
  document.querySelector("#app").classList.remove("rtl");

  body.classList.add("bg-gray-100");


});


const onlyDigits = /^[0-9]{11}$/;

let step = ref(1);
let mobile = ref("");
let mobileClasses = ref('');

let allowSubmit = ref(false);
let loading = ref(false);


let code = ref("");

console.info(step.value, 'step')


const goBack = () => {
  step.value = 1;
}
const validateMobile = () => {
  // validate mobile
  if (mobile.value.length == 0) {
    mobileClasses.value = '';
  } else if (!onlyDigits.test(mobile.value)) {
    mobileClasses.value = 'is-invalid';
    allowSubmit.value = false;
  } else if (mobile.value.length !== 11) {
    mobileClasses.value = 'is-invalid';
    allowSubmit.value = false;
  } else {
    mobileClasses.value = 'is-valid';
    allowSubmit.value = true;
  }

}


const verifyOtp = async function () {
// send mobile to server
  await axios.post(`${apiUrl}/verify-otp`,
      {
        mobile: mobile.value,
        code: code.value
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }).then((response) => {
    console.info('response', response);

    let data = response.data;
    console.info('data', data);
    console.info('data.success', data.success);

    if (data.success) {

      localStorage.setItem("user_step", data.step); // یا از Vuex/Pinia بگیر
      localStorage.setItem("token", data.token); // یا از Vuex/Pinia بگیر
      authStore.setToken(data.token);

      if (data.step == 1) {
        //redirect to fill information
        toast.info("در حال هدایت به صفحه تکمیل اطلاعات حساب کاربری!");
        router.push({name: 'fill-profile'});
      } else {
        //redirect to dashboard
        toast.success("در حال هدایت به داشبورد هستید!");
        router.push({name: '/'});
      }
    }

  }).catch((error) => {
    console.info('error', error);
    const errMsg = error.response?.data?.message ?? error.message;
    toast.error(`${error.response.status}:${errMsg}`);
  });

  loading.value = false;
};

const sendOtp = async () => {
  console.info("step.value : " + step.value);
  console.info("mobile : " + mobile.value);
  console.info("code : " + code.value);

  loading.value = true;
  //todo validate mobile
  if (mobile.value.length != 11) {
    loading.value = false;
    toast.error("شماره موبایل باید 11 رقم باشد");
    return;
  }

  if (step.value === 2) {
    loading.value = true;

    console.info('code.value.length', code.value.length);
    if (code.value.length == 5) {
      await verifyOtp();
      return;
    }else{
      loading.value = false;
      // toast.error("کد اعتبارسنجی باید  5 رقم باشد");
      return;
    }



  } else if (step.value === 1) {

    await axios.post(`${apiUrl}/send-otp`,
        {mobile: mobile.value},
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }).then((response) => {

      let data = response?.data;

      if (data?.success) {
        step.value = 2;
        console.info('data', data);
        toast.info("کد با موفقیت ارسال شد!")
      } else {
        step.value = 1;
        toast.error(data.massage);
      }

    }).catch((error) => {
      console.info('error', error);
      const errMsg = error.response?.data?.message ?? error?.message;
      toast.error(errMsg);
    });

    loading.value = false;

  }


}



let codeClasses = ref('');
const validateCode = () => {
  //todo validate mobile
  allowSubmit.value = false;

  if (mobile.value.length == 0) {
    codeClasses.value = '';
  } else if (code.value.length < 4) {
    codeClasses.value = 'is-invalid';
  } else {
    codeClasses.value = 'is-valid';
    allowSubmit.value = true;
    sendOtp();
  }

}





</script>
<template>

  <main class="mt-0 main-content">
    <section class="container px-0">
      <div class="page-header min-vh-100">
        <div class="container px-0">
          <div class="row ">
            <div
                class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute start-0 justify-content-center flex-column"
            >
              <div
                  class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                  :style="{ backgroundImage: `url(${loginImage})`, backgroundSize: 'cover',backgroundPosition: 'center' }"
              >

              </div>
            </div>
            <div
                class="mx-auto col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                <div class="pb-0 card-header ">
                  <h4 class="font-weight-bolder">ورود با شماره موبایل</h4>

                  <template v-if="step === 1">
                    <p class="mb-0">شماره موبایل خود را جهت دریافت کد احراز هویت و ورود به سایت وارد کنید</p>
                  </template>
                  <template v-else>
                    <div class="d-flex justify-content-between">
                      <p class="mb-0">کد تایید برای شماره <span class="font-weight-bold">{{ mobile }}</span> پیامک شد
                      </p>
                      <p class="mb-0 text-info cursor-pointer" @click="goBack">
                        <i class="fa fa-edit"></i>
                        ویرایش
                      </p>
                    </div>
                  </template>

                </div>
                <div class="card-body">
                  <form role="form">

                    <div class="mb-3" v-show="step === 1 ">
                      <label for="mobile">شماره موبایل</label>

                      <argon-input
                          id="mobile"
                          autocomplete="mobile"
                          type="text"
                          inputmode="numeric"
                          dir="ltr"
                          v-model="mobile"
                          placeholder="09*********"
                          :class="mobileClasses"
                          class="letter-spacing-2"
                          name="mobile"
                          size="lg"
                          @keydown.enter="sendOtp"
                          @keydown.tab="sendOtp"
                          @keyup="validateMobile"
                          @input="validateMobile"
                      />
                    </div>

                    <div class="mb-3" v-show="step === 2 ">
                      <!--                      <label for="code">کد احراز هویت (OTP)</label>-->
                      <argon-input
                          id="code"
                          type="text"
                          inputmode="numeric"
                          dir="ltr"
                          placeholder="- - - - "
                          :class="codeClasses"
                          v-model="code"
                          class="text-center letter-spacing-3"
                          name="code"
                          size="lg"
                          @keyup="validateCode"
                      />
                    </div>


                    <div class="text-center">

                      <argon-button
                          :disabled="!allowSubmit"
                          class="mt-4 px-1"
                          variant="gradient"
                          :color="step == 1 ? 'info' : 'success' "
                          fullWidth
                          size="lg"
                          type="button"
                          @click="sendOtp"
                      >
                        <span v-show="step === 1">
                          <i class="fa fa-mobile  ms-1"></i>
                       <span>   دریافت کد اعتبارسنجی</span>
                        </span>
                        <span v-show="step === 2">
                          <i class="fa fa-sm ms-1 fa-reply-all"></i>
                          <span>اعتبارسنجی</span>
                        </span>


                        <span v-show="loading">
                          <i class="fa fa-spinner fa-spin me-3 "></i>
                        </span>

                      </argon-button>

                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    حساب کاربری ندارید؟
                    <a
                        href="javascript:;"
                        class="text-success text-gradient font-weight-bold"
                    >ثبت نام</a
                    >
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </main>
</template>
